import React from 'react'
import { useHistory } from "react-router-dom";
import AppEvent from '../Helpers/AppEvent'

const useCustomHistory = (props) => {

    const history = useHistory();
    const push = (obj) => {
        if (!AppEvent(props)){
            history.push(obj)
        }
    }

    return { push };

}

export default useCustomHistory
